/*
 * Site JS document
 * Site-specific support javascript, load after util
 */

/**
 * Global namespace, contains all custom JS within sub-namespaces.
 * @namespace
 */
var ZOL = ZOL || {};

/**
 * Site-specific code, outside of modular-level functionality or global, utility-level code.
 * @namespace
 */
ZOL.site = ZOL.site || {};

/* Navigation
============================================================= */

ZOL.site.nav = function(el) {
	var isActive = false;
	var $container = $('.site--header');
	var $hamburger = $container.find('.hamburger');
	var $overlay = $container.find('.overlay');

	var open = function() {
		isActive = true;
		$overlay.addClass('active');
		$hamburger.addClass('active');
		$('html').addClass('no-scroll');
		$(document).on('keydown', keydownHandler);
	};

	var close = function() {
		isActive = false;
		$overlay.removeClass('active');
		$hamburger.removeClass('active');
		$('html').removeClass('no-scroll');
		$(document).off('keydown', keydownHandler);
	};

	var toggle = function() {
		isActive ? close() : open();
	};

	var keydownHandler = function(event) {
		if (event.which === 27) {
			close();
		}
	};

	$hamburger.on('click', toggle);
};

/* Disclosure Class
 * Pass in your control and content and behavior will be added
 * that toggles the visibility of the content on click.
 *
 * new ZOL.site.Disclosure(control, content)
============================================================= */

// Define Disclosure
ZOL.site.Disclosure = function(control, content) {
	this.$control = $(control);
	this.$content = $(content);
	this.init();
};

// Define Disclosure methods
ZOL.site.Disclosure.prototype = {
	init: function() {
		// Set accessibility attributes on the control
		this.$control.attr('role', 'button');
		this.$control.attr('aria-controls', this.$content.attr('id') || '');

		// Get the initial display value (block, inline, flex, etc)
		this.initialDisplay = window.getComputedStyle(this.$content[0]).display;

		// Start out collapsed
		this.collapse();

		// Add the listener for toggling the content
		this.$control.on('click', this.toggle.bind(this));
	},

	expand: function() {
		// Expand the content
		this.$control.attr('aria-expanded', 'true');
		this.$content.css('display', this.initialDisplay);
	},

	collapse: function() {
		// Collapse the content
		this.$control.attr('aria-expanded', 'false');
		this.$content.css('display', 'none');
	},

	toggle: function() {
		// Toggle the content
		this.$control.attr('aria-expanded') === 'true' ? this.collapse() : this.expand();
	},
};

/* Get Product Data Schema
 * Fetch the JSON file which contains the list of tags available
 * to products, e.g. Colors, Genders, Materials, Stones...
============================================================= */

ZOL.site.getProductDataSchema = function() {
	return $.getJSON($('.product-data-schema').data('json-url'));
};

/* Document Ready
============================================================= */

$(document).ready(function() {
	ZOL.site.nav();
	ZOL.util.initializeBinds('body', 'page--', ZOL.pages);
});